/* eslint-disable prettier/prettier */
import { Assessment, FilteredInfo } from '../../interfaces';
import React, { FC, RefObject, useState } from 'react';
import { ColumnProps } from 'antd/es/table';
import { PaginationConfig } from 'antd/lib/pagination';
import { Input } from 'antd';
import { ClearAllFiltersButton, CustomizedTable } from './style';
import { getColumnSearchProps } from './Filter';
import { useHistory } from 'react-router-dom';
import { PostButtonWithHistory } from './PostButton';

interface TableLayoutProps {
  dataSource: Assessment[];
}

const initFilteredInfo = {
  assessmentId: [],
  schoolName: [],
  building: [],
  room: [],
  recommendedWork: [],
};

export const TableLayout: FC<TableLayoutProps> = ({ dataSource = [] }) => {
  const [filteredInfo, setFilteredInfo] = useState<FilteredInfo>(initFilteredInfo);
  const searchInput: RefObject<Input> = React.createRef<Input>();
  const history = useHistory();
  const getColumnsConfig = (): ColumnProps<Assessment>[] => [
    {
      title: 'ID',
      dataIndex: 'assessmentId',
      key: 'assessmentId',
      sorter: (a, b) => a.assessmentId - b.assessmentId,
      render: function RenderID(id: string) {
        return <a>{id}</a>;
      },
      ...getColumnSearchProps('assessmentId', filteredInfo, setFilteredInfo, searchInput),
    },
    {
      title: 'School Name',
      dataIndex: 'schoolName',
      key: 'schoolName',
      sorter: (a, b) => a.region.localeCompare(b.region),
      ...getColumnSearchProps('schoolName', filteredInfo, setFilteredInfo, searchInput),
    },
    {
      title: 'Building',
      dataIndex: 'building',
      key: 'building',
      sorter: (a, b) => a.region.localeCompare(b.region),
      ...getColumnSearchProps('building', filteredInfo, setFilteredInfo, searchInput),
    },
    {
      title: 'Room',
      dataIndex: 'room',
      key: 'room',
      sorter: (a, b) => a.region.localeCompare(b.region),
      ...getColumnSearchProps('room', filteredInfo, setFilteredInfo, searchInput),
    },
    {
      title: 'Recommended Work',
      dataIndex: 'recommendedWork',
      key: 'recommendedWork',
      sorter: (a, b) => a.region.localeCompare(b.region),
      ...getColumnSearchProps('recommendedWork', filteredInfo, setFilteredInfo, searchInput),
    },
    {
      title: 'Action',
      key: 'action',
      render: PostButtonWithHistory(history),
    },
  ];

  const columns: ColumnProps<Assessment>[] = getColumnsConfig();

  const paginationConfig: PaginationConfig = {
    size: 'small',
    position: 'both',
    defaultPageSize: 20,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  };

  const clearAllFilters = () => {
    setFilteredInfo(initFilteredInfo);
  };

  return (
    <>
      <ClearAllFiltersButton onClick={() => clearAllFilters()}>Reset Filters</ClearAllFiltersButton>
      <CustomizedTable<Assessment>
        rowKey={record => `${record.id}`}
        columns={columns}
        dataSource={dataSource}
        pagination={paginationConfig}
        tableLayout="auto"
        scroll={{ x: '100%' }}
      />
      <ClearAllFiltersButton onClick={() => clearAllFilters()}>Reset Filters</ClearAllFiltersButton>
    </>
  );
};
